import React from "react";

const BioCard = ({ driver, totalGroupedTrips }) => (
  <div className="lg:col-span-1 bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col justify-between">
    <div>
      <h3 className="text-xl font-bold tracking-tight leading-tight">
        {driver.full_name || "—"}
      </h3>
      <p className="text-xs font-medium text-gray-500 mt-1">
        ID: {driver.employee_id || driver.id || "—"}
      </p>
    </div>
    <div className="mt-6 flex items-end justify-between">
      <div className="bg-gray-50 px-4 py-2.5 rounded-lg border border-gray-200">
        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">
          Total Trips
        </p>
        <p className="text-2xl font-bold text-purple-800">{totalGroupedTrips}</p>
      </div>
    </div>
  </div>
);

export default BioCard;
